import { Classification } from "@/components/Classification";
import styled from "@emotion/styled";
import { type Opportunity } from "@repo/api";
import { FormField, RadioButtonGroup, TextArea } from "@repo/skapa";
import { t } from "@repo/translation";
import {
  SectionContainer,
  translateClassificationReason,
  useSettings,
} from "@repo/ui";
import { trackAnalytics } from "@repo/utils";

import { type ClassificationState } from "./types.ts";

const classifications: Opportunity["classification"][] = [
  "Urgent",
  "High",
  "Medium",
  "Low",
];
const SkapaOverride = styled.div`
  .saleslead__radio {
    align-items: center;
    line-height: 0;
  }
`;
export const ClassificationSelections = ({
  state,
  setState,
}: {
  state: ClassificationState;
  setState: (newState: ClassificationState) => void;
}) => {
  const { general } = useSettings();
  const reasons = general?.reasons?.classification_change;

  return (
    <SkapaOverride>
      <SectionContainer>
        <RadioButtonGroup
          name={t("action.change_classification")}
          list={classifications.map((classification) => ({
            id: classification,
            name: "group1",
            value: classification,
            label: (
              <Classification
                classification={classification}
                id={classification}
                showLabel
              />
            ),
            defaultChecked: classification === state.classification,
            onChange: (e: any) => {
              setState({
                ...state,
                classification: e.target.value,
              });
              trackAnalytics("change_classification");
            },
          }))}
        />
        {reasons && (
          <RadioButtonGroup
            name={t("action.select_reason")}
            list={reasons.map((key) => ({
              name: "group2",
              id: key,
              label: translateClassificationReason(key),
              value: key,
              defaultChecked: key === state.reason,
              onChange: (e: any) => {
                setState({
                  ...state,
                  reason: e.target.value,
                });
                trackAnalytics("select_classification_change_reason");
              },
            }))}
          />
        )}

        <FormField
          shouldValidate
          valid={
            state.reason !== "OTHER" ||
            Boolean(state.description && state.description.length > 3)
          }
          validation={{
            msg: t("prompt.error_min_3_characters"),
            id: "error",
            type: "error",
          }}
        >
          <TextArea
            id="reason"
            label={t("action.describe_reason")}
            value={state.description}
            onChange={(e) => {
              setState({
                ...state,
                description: e.target.value,
              });
              trackAnalytics("describe_classification_change_reason");
            }}
          />
        </FormField>
      </SectionContainer>
    </SkapaOverride>
  );
};
